/**
 * Safe date parsing with validation.
 * Returns null if date is invalid instead of throwing.
 */
export function safeParseDate(isoString?: string | null): Date | null {
  if (!isoString) return null;

  try {
    const d = new Date(isoString);
    // Check if date is valid
    if (isNaN(d.getTime())) {
      console.warn('[safeParseDate] Invalid date string:', isoString);
      return null;
    }
    return d;
  } catch (err) {
    console.warn('[safeParseDate] Error parsing date:', isoString, err);
    return null;
  }
}

/**
 * Format a date to locale time string, with fallback for invalid dates.
 */
export function formatTime(timestamp?: string | null): string {
  const date = safeParseDate(timestamp);
  if (!date) return 'Invalid time';

  try {
    return date.toLocaleTimeString();
  } catch (err) {
    console.warn('[formatTime] Error formatting date:', timestamp, err);
    return 'Invalid time';
  }
}

/**
 * Format date to ISO string, with fallback.
 */
export function formatISOString(timestamp?: string | null): string {
  const date = safeParseDate(timestamp);
  if (!date) return 'Invalid date';

  try {
    return date.toISOString();
  } catch (err) {
    console.warn('[formatISOString] Error formatting date:', timestamp, err);
    return 'Invalid date';
  }
}
